import { React, useState, useContext, useEffect, useMemo } from "react";
import { Flex, Heading, Text, MNotification, Container, MTable, Button, PencilSimple, MTabs, Modal, MRadio, MLink, Search } from "@cisco/spaces-dash-lib-styleguide";
import { useNotification } from "@cisco/spaces-dash-app-business-hierarchy";
import { AppContext } from "../../contexts/AppContext";
import * as PartnerHomeService from "../../service/partner-dashboard-service";
import { PropertiesContext } from "../../contexts/propertiesContext";
import { rolesFormatter } from "../roles";
import "./user-management.scss";

function UserManagement(props) {
  const { isPartnerDashboard: isPartnerDashboardProp, i18n } = props;
  const [isPartnerDashboard, setIsPartnerDashboard] = useState(false);
  const { properties } = useContext(PropertiesContext);
  const { setToastMessage } = useNotification();
  const [users, setUsers] = useState([]);
  const [usersListFromServer, setUsersListFromServer] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [currentUserRoles, setCurrentUserRoles] = useState([]);
  const [usersFetched, setUsersFetched] = useState(false);
  const [roles, setRoles] = useState([]);
  const [rolesFetched, setRolesFetched] = useState(false);
  const [selectOneRole, setSelectOneRole] = useState(false);
  const [searchBy, setSearchBy] = useState("");
  const [userSelectedForRoleUpdate, setUserSelectedForRoleUpdate] = useState("");
  const [userRolesAvailable] = useState([
    {
      key: "PartnerDashboardReadWrite",
      label: i18n.t("partner-dashboard-app.partner-apps.partner-apps-rbac.rbac-home.partner-dashboard-read-write-text"),
      value: "PartnerDashboardReadWrite"
    },
    {
      key: "PartnerDashboardReadOnly",
      label: i18n.t("partner-dashboard-app.partner-apps.partner-apps-rbac.rbac-home.partner-dashboard-read-only-text"),
      value: "PartnerDashboardReadOnly"
    }
  ]);
  const [currentuserRole, setCurrentuserRole] = useState("None");
  const [previousUserRole, setPreviousUserRole] = useState("None");
  const [isUpdateUserRolePopupOpen, setIsUpdateUserRolePopupOpen] = useState(false);
  const [selectedTab, setSelectedTab] = useState("users");
  let usersWithRoles = [];

  useEffect(() => {
    if (isPartnerDashboardProp) {
      setIsPartnerDashboard(true);
    }
    console.log(`${selectOneRole} ${currentUserRoles}`);
  }, [isPartnerDashboardProp, setIsPartnerDashboard]);

  useEffect(() => {
    i18n.loadNamespaces("partners-home");
    i18n.setDefaultNamespace("partners-home");
  }, [i18n]);

  const appContextValue = useMemo(() => ({ isPartnerDashboard }), [isPartnerDashboard]);

  const openLink = () => {
    window.open(properties.dnaspacesDashboardUsUrl, "_blank");
  };

  const onClearSearch = () => {
    setSearchBy("");
    setFilteredUsers(users);
  };

  const getPartnerRBACUsers = () => {
    setUsersFetched(false);
    onClearSearch();
    PartnerHomeService.getRBACUsers()
      .then((data) => {
        if (data.status && data.data) {
          setUsersFetched(true);
          usersWithRoles = [];
          const fusers = data.data;
          setUsersListFromServer(fusers);
          fusers.forEach((user) => {
            const obj = {
              userName: user.user,
              dashboardRoles: [],
              partnerRoles: [],
              roleId: user.roleId ? user.roleId : ""
            };
            if (user.roleType === "DB") {
              obj.dashboardRoles.push(user.roleName);
            }
            if (user.roleType !== "DB" && user.spacesRoleName) {
              obj.dashboardRoles.push(user.spacesRoleName);
            }
            if (user.roleType === "PD") {
              obj.partnerRoles.push(user.roleName);
            }
            usersWithRoles.push(obj);
          });
          setUsers(usersWithRoles);
          setFilteredUsers(usersWithRoles);
        } else {
          setUsersFetched(true);
        }
      })
      .catch((error) => {
        setUsersFetched(true);
        console.error(`UserManagement: Error on getPartnerRBACUsers ${error}`);
      });
  };

  const showUserManagementTab = (tab) => {
    setSelectedTab(tab);
  };

  const getCurrentUserList = (selecteduser) => {
    const userCurrentRoles = [];
    const items = usersListFromServer.filter((item) => item.user == selecteduser);
    for (let i = 0; i < items.length; i++) {
      userCurrentRoles.push(items[i].roleName);
      if (items[i].roleType == "PD") {
        if (items[i].roleName == "PartnerDashboardReadWrite") {
          setCurrentuserRole("PartnerDashboardReadWrite");
          setPreviousUserRole("PartnerDashboardReadWrite");
        } else if (items[i].roleName == "PartnerDashboardReadOnly") {
          setCurrentuserRole("PartnerDashboardReadOnly");
          setPreviousUserRole("PartnerDashboardReadOnly");
        }
      } else {
        setCurrentuserRole("None");
        setPreviousUserRole("None");
      }
    }
    setCurrentUserRoles(userCurrentRoles);
  };

  const getPartnerRBACRoles = () => {
    setRolesFetched(false);
    PartnerHomeService.getRBACRoles()
      .then((data) => {
        setRolesFetched(true);
        if (data.status && data.data) {
          setRoles(data.data);
        }
      })
      .catch((error) => {
        setRolesFetched(true);
        console.error(`UserManagement: Error on getPartnerRBACRoles ${error}`);
      });
  };

  const editRoleActionhandler = (row) => {
    if (row && row.original && row.original.userName) {
      setUserSelectedForRoleUpdate(row.original.userName);
      getCurrentUserList(row.original.userName);
      setSelectOneRole(false);
      setIsUpdateUserRolePopupOpen(true);
    } else {
      console.log(`Error on editRoleActionhandler ${row}`);
    }
  };

  const getActionsCellValue = ({ row }) => {
    return (
      <Flex justify="flex-start">
        <Button.Group>
          <Button
            onClick={() => {
              editRoleActionhandler(row);
            }}
            id={`edit-action-for-${row.original.userName}`}
            disabled={!!row.original.roleId}
            icon={<PencilSimple size={16} weight="bold" />}
            kind="tertiary"
            className="lh20-metadata-edit-button"
          />
        </Button.Group>
      </Flex>
    );
  };

  const cancelUpdateRolePopup = () => {
    setIsUpdateUserRolePopupOpen(false);
    setCurrentuserRole("None");
    setSelectOneRole(false);
    setCurrentUserRoles([]);
    setUserSelectedForRoleUpdate("");
  };

  const updateRBACUserRoles = () => {
    if (currentuserRole !== "None") {
      const request = {
        selectedUserRoles: [currentuserRole],
        email: userSelectedForRoleUpdate
      };
      PartnerHomeService.updateRBACUserRole(request)
        .then((data) => {
          console.log(data);
          getPartnerRBACUsers();
          getPartnerRBACRoles();
          cancelUpdateRolePopup();
          setToastMessage(i18n.t("partner-dashboard-app.partner-apps.partner-apps-rbac.rbac-home.role-updated-successfully-msg"), 5000, "positive");
        })
        .catch((error) => {
          setToastMessage(i18n.t("partner-dashboard-app.partner-apps.partner-apps-rbac.rbac-home.role-update-failed-msg"), 5000, "negative");
          console.error(`UserManagement: Error on updateRBACUserRoles ${error}`);
          cancelUpdateRolePopup();
        });
    } else {
      setSelectOneRole(true);
    }
  };

  const selectRole = (event) => {
    if (event && event.target && event.target.value) {
      setCurrentuserRole(event.target.value);
    }
  };

  const searchByUser = (e) => {
    const searchText = e.target.value;
    if (searchText) {
      setSearchBy(e.target.value);
      const results = users.filter((user) => {
        return user?.userName?.toLowerCase().includes(searchBy?.toLowerCase());
      });
      setFilteredUsers(results);
    } else {
      setSearchBy("");
      setFilteredUsers(users);
    }
  };

  const updateUserRolePopup = () => {
    return (
      <Modal size="md" isOpen={isUpdateUserRolePopupOpen}>
        <Flex direction="vertical">
          <Heading id="edit-user-role" style={{ "margin-bottom": "10px" }}>
            {i18n.t("partner-dashboard-app.partner-apps.partner-apps-rbac.rbac-home.update-user-role-text")}
          </Heading>
        </Flex>
        <Modal.Content>
          <Flex direction="vertical" style={{ margin: "18px" }} gap={20}>
            <Flex direction="horizontal">
              <Text size="p3" weight="semi-bold">
                {`${i18n.t("partner-dashboard-app.partner-apps.partner-apps-rbac.rbac-home.user-name-text")}: `}
              </Text>
              &nbsp;&nbsp;
              <Text size="p3" color="light" id={`user-for-${userSelectedForRoleUpdate}`}>
                {userSelectedForRoleUpdate}
              </Text>
            </Flex>
            <Flex>
              <MRadio
                size="sm"
                legend={i18n.t("partner-dashboard-app.partner-apps.partner-apps-rbac.rbac-home.roles-text")}
                onChange={(e) => {
                  selectRole(e);
                }}
                options={userRolesAvailable}
                value={currentuserRole}
              />
            </Flex>
          </Flex>
        </Modal.Content>
        <Flex justify="flex-end" style={{ "margin-top": "10px" }}>
          <Button.Group>
            <Button kind="secondary" onClick={cancelUpdateRolePopup} id="user-role-cancel">
              {i18n.t("partner-dashboard-app.auth.change-password.cancel-text")}
            </Button>

            <Button
              kind="primary"
              disabled={!!(currentuserRole === previousUserRole || currentuserRole === "None")}
              title="Please select/change the role"
              id="user-role-save"
              onClick={updateRBACUserRoles}
            >
              {i18n.t("partner-dashboard-app.partner-apps.partner-app-center.save-text")}
            </Button>
          </Button.Group>
        </Flex>
      </Modal>
    );
  };

  useEffect(() => {
    console.log("UserManagement Mount");
    console.log(properties);
    getPartnerRBACUsers();
    getPartnerRBACRoles();

    return () => {
      console.log("UserManagement Destroy");
    };
  }, []);

  return (
    <AppContext.Provider value={appContextValue}>
      {isUpdateUserRolePopupOpen && updateUserRolePopup()}
      <Flex direction="vertical" style={{ margin: "24px 24px 0px 24px" }}>
        <Flex direction="vertical" gap={8}>
          <Heading size="primary">{i18n.t("partner-dashboard-app.shared.header-spaces.user-management-text")}</Heading>
          <MNotification banner="page">
            <Flex id="note-text-for-invite">
              <Text size="p4" weight="semi-bold">
                {`${i18n.t("partner-dashboard-app.partner-apps.app-center.note-text")}: `}
              </Text>
              &nbsp;
              <Text size="p4" weight="regular" color="light">
                {`${i18n.t("partner-dashboard-app.partner-apps.partner-apps-rbac.rbac-home.to-invite-new-user-login-text")} `}{" "}
                <MLink id="eu-region-link" size="sm" onClick={openLink}>
                  {i18n.t("partner-dashboard-app.partner-apps.partner-apps-rbac.rbac-home.spaces-dashboard-text")}
                </MLink>
              </Text>
            </Flex>
          </MNotification>
          <Flex direction="vertical">
            <MTabs kind="secondary">
              <MTabs.Link id="users-tab" onClick={() => showUserManagementTab("users")} selected={selectedTab == "users"}>
                {i18n.t("partner-dashboard-app.location.manage-location-tree.users-text")}
              </MTabs.Link>
              <MTabs.Link id="roles-tab" onClick={() => showUserManagementTab("roles")} selected={selectedTab == "roles"}>
                {i18n.t("partner-dashboard-app.partner-apps.partner-apps-rbac.rbac-home.roles-text")}
              </MTabs.Link>
            </MTabs>
          </Flex>
        </Flex>
        <Flex direction="vertical" style={{ margin: "24px 0px 0px 0px" }}>
          {(() => {
            switch (selectedTab) {
              case "users":
                return (
                  users && (
                    <Container>
                      <Flex direction="vertical" gap={16}>
                        {/* Show search only when there are results OR user has typed something in search */}
                        {((filteredUsers && filteredUsers.length > 0) || (searchBy && searchBy.length > 0)) && (
                          <Flex justify="space-between">
                            <Flex align="center" gap={16}>
                              <Flex gap={8}>
                                <Search
                                  id="search-user"
                                  onChange={(e) => {
                                    searchByUser(e);
                                  }}
                                  onClear={onClearSearch}
                                  options={[]}
                                  placeholder="Search"
                                  value={searchBy}
                                  label=""
                                  size="md"
                                />
                              </Flex>
                            </Flex>
                          </Flex>
                        )}
                        <MTable.Pagination key={filteredUsers.length} currentPage={1} defaultRecordsOption="10" showNavigation="all" showTotal showOptions>
                          <MTable
                            containerClassName="partner-user-table"
                            style={{ padding: "0px" }}
                            id="user-list-table"
                            isLoading={!usersFetched}
                            columns={[
                              {
                                accessorKey: "userName",
                                header: i18n.t("partner-dashboard-app.auth.login.login-partner-base.switch-user-text"),
                                meta: {
                                  align: "left"
                                },
                                cell: (data) => (
                                  <MLink id="eu-region-link" size="md">
                                    {data.getValue() !== undefined ? data.renderValue() : "—"}
                                  </MLink>
                                )
                              },
                              {
                                accessorKey: "dashboardRoles",
                                header: i18n.t("partner-dashboard-app.partner-apps.partner-apps-rbac.rbac-home.cisco-spaces-dashboard-user-roles-text"),
                                meta: {
                                  align: "left"
                                },
                                cell: (data) => rolesFormatter(data, i18n.t("partner-dashboard-app.partner-apps.partner-apps-rbac.rbac-home.cisco-spaces-dashboard-user-roles-text"))
                              },
                              {
                                accessorKey: "partnerRoles",
                                header: i18n.t("partner-dashboard-app.partner-apps.partner-apps-rbac.rbac-home.partner-dashboard-user-roles-text"),
                                meta: {
                                  align: "left"
                                },
                                cell: (data) => rolesFormatter(data, i18n.t("partner-dashboard-app.partner-apps.partner-apps-rbac.rbac-home.partner-dashboard-user-roles-text"))
                              },
                              {
                                accessorKey: "number",
                                cell: getActionsCellValue,
                                meta: {
                                  align: "left"
                                },
                                header: i18n.t("partner-dashboard-app.partner-apps.partner-apps-rbac.rbac-home.edit-partner-dashboard-user-roles")
                              }
                            ]}
                            data={filteredUsers}
                          />
                        </MTable.Pagination>
                      </Flex>
                    </Container>
                    // <Flex direction="vertical" gap={15}>
                    //   <Flex direction="horizontal" justify="space-between">
                    //     <Flex style={{ height: "35px" }}>
                    //       <Search
                    //         id="search-user"
                    //         onChange={(e) => {
                    //           searchByUser(e);
                    //         }}
                    //         onClear={onClearSearch}
                    //         options={[]}
                    //         placeholder="Search"
                    //         value={searchBy}
                    //         label=""
                    //         size="md"
                    //       />
                    //     </Flex>
                    //     <Flex>
                    //       <MNotification status="informational" size="sm">
                    //         <Flex id="note-text-for-invite">
                    //           <Text size="p4" weight="semi-bold">
                    //             {`${i18n.t("partner-dashboard-app.partner-apps.app-center.note-text")}: `}
                    //           </Text>
                    //           &nbsp;
                    //           <Text size="p4" weight="regular" color="light">
                    //             {`${i18n.t("partner-dashboard-app.partner-apps.partner-apps-rbac.rbac-home.to-invite-new-user-login-text")} `}{" "}
                    //             <MLink id="eu-region-link" size="sm" onClick={openLink}>
                    //               {i18n.t("partner-dashboard-app.partner-apps.partner-apps-rbac.rbac-home.spaces-dashboard-text")}
                    //             </MLink>
                    //           </Text>
                    //         </Flex>
                    //       </MNotification>
                    //     </Flex>
                    //   </Flex>
                    //   <Flex>
                    //     <STable
                    //       id="user-list-table"
                    //       enableRowActions={false}
                    //       enablePagination
                    //       isLoading={!usersFetched}
                    //       columns={[
                    //         {
                    //           accessorKey: "userName",
                    //           header: i18n.t("partner-dashboard-app.auth.login.login-partner-base.switch-user-text"),
                    //           meta: {
                    //             align: "left"
                    //           },
                    //           cell: (data) => (
                    //             <MLink id="eu-region-link" size="md">
                    //               {data.getValue() !== undefined ? data.renderValue() : "—"}
                    //             </MLink>
                    //           )
                    //         },
                    //         {
                    //           accessorKey: "dashboardRoles",
                    //           header: i18n.t("partner-dashboard-app.partner-apps.partner-apps-rbac.rbac-home.cisco-spaces-dashboard-user-roles-text"),
                    //           meta: {
                    //             align: "left"
                    //           },
                    //           cell: (data) => rolesFormatter(data, i18n.t("partner-dashboard-app.partner-apps.partner-apps-rbac.rbac-home.cisco-spaces-dashboard-user-roles-text"))
                    //         },
                    //         {
                    //           accessorKey: "partnerRoles",
                    //           header: i18n.t("partner-dashboard-app.partner-apps.partner-apps-rbac.rbac-home.partner-dashboard-user-roles-text"),
                    //           meta: {
                    //             align: "left"
                    //           },
                    //           cell: (data) => rolesFormatter(data, i18n.t("partner-dashboard-app.partner-apps.partner-apps-rbac.rbac-home.partner-dashboard-user-roles-text"))
                    //         },
                    //         {
                    //           accessorKey: "number",
                    //           cell: getActionsCellValue,
                    //           meta: {
                    //             align: "right"
                    //           },
                    //           header: i18n.t("partner-dashboard-app.partner-apps.partner-apps-rbac.rbac-home.edit-partner-dashboard-user-roles")
                    //         }
                    //       ]}
                    //       data={filteredUsers}
                    //     />
                    //   </Flex>
                    // </Flex>
                  )
                );

              case "roles":
                return (
                  roles && (
                    <MTable
                      id="role-list-table"
                      isLoading={!rolesFetched}
                      columns={[
                        {
                          accessorKey: "roleName",
                          header: i18n.t("partner-dashboard-app.partner-apps.partner-apps-rbac.rbac-home.role-text"),
                          meta: {
                            align: "left"
                          },
                          cell: (data) => <Text size="p3">{data.getValue() !== undefined ? data.renderValue() : "—"}</Text>
                        },
                        {
                          accessorKey: "permissions",
                          header: i18n.t("partner-dashboard-app.partner-apps.partner-apps-rbac.rbac-home.permission-type-text"),
                          meta: {
                            align: "left"
                          },
                          cell: (data) => rolesFormatter(data, i18n.t("partner-dashboard-app.partner-apps.partner-apps-rbac.rbac-home.permission-type-text"))
                        }
                      ]}
                      data={roles}
                    />
                  )
                );

              default:
                return <> </>;
            }
          })()}
        </Flex>
      </Flex>
    </AppContext.Provider>
  );
}

export default UserManagement;
